import { getEventCategoryIcon } from '@/components/doohReport/common/helpers/eventCategoryIcon.helpers';

import type { DoohReportEventCategory } from 'sonata-static-storage/lib/entities/doohReport/doohReport.types';

import './eventCategoryIcon.scss';

type Props = {
  category: DoohReportEventCategory | null;
};

export default function EventCategoryIcon({ category }: Readonly<Props>) {
  return (
    <span className="eventCategoryIcon">
      <i aria-hidden="true" className={getEventCategoryIcon(category)} />
    </span>
  );
}
